import { render } from "./PartnerManageListForm.vue?vue&type=template&id=6614464c&lang=true"
import script from "./PartnerManageListForm.vue?vue&type=script&lang=js"
export * from "./PartnerManageListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__